export const POLICY_IDS = [
  'no_smoking',
  'no_pets',
  'no_parties',
  'quiet_hours',
  'no_unregistered_guests',
  'check_in_id',
] as const;

export type PolicyId = (typeof POLICY_IDS)[number];

export interface PolicyOption {
  id: PolicyId;
  nameKey: string;
  descriptionKey: string;
}

export const POLICY_OPTIONS: PolicyOption[] = POLICY_IDS.map(id => ({
  id,
  nameKey: `RENTAL.WIZARD.POLICIES.${id.toUpperCase()}.NAME`,
  descriptionKey: `RENTAL.WIZARD.POLICIES.${id.toUpperCase()}.DESCRIPTION`,
}));
